import * as React from 'react';
const DroneIcon = props => (
    <svg
        width={20}
        height={20}
        viewBox='0 0 20 20'
        aria-label='Drone'
        role='img'
        fill='none'
        stroke='currentColor'
        strokeWidth={1.6}
        strokeLinecap='round'
        strokeLinejoin='round'
        {...props}
    >
        <circle cx={12} cy={12} r={2.5} />
        <line x1={8.5} y1={8.5} x2={10.7} y2={10.7} />
        <line x1={13.3} y1={13.3} x2={15.5} y2={15.5} />
        <line x1={8.5} y1={15.5} x2={10.7} y2={13.3} />
        <line x1={13.3} y1={10.7} x2={15.5} y2={8.5} />
        <circle cx={6.5} cy={6.5} r={1.6} />
        <circle cx={17.5} cy={6.5} r={1.6} />
        <circle cx={6.5} cy={17.5} r={1.6} />
        <circle cx={17.5} cy={17.5} r={1.6} />
    </svg>
);

export default DroneIcon;
